import React, { useEffect, useState } from 'react';
const ExpressPaymentsButtonApplepay = (props) => {
    const [enabled, setEnabled] = useState();
    const [startPayment, setStartPayment] = useState();
    useEffect(() => {
        if (startPayment && props.confirmed) {
            // triggered in ExpressPaymentsButtons on placeorder click
            // "Must create a new ApplePaySession from a user gesture handler"
            // (document.getElementById('applepaybutton') as HTMLButtonElement).click();
        }
    }, [startPayment, props.confirmed]);
    // OE-24851 workaround to use both arrow with different behaviors
    const hideArrowAfterClick = () => {
        const paymentDiv = document.querySelector('.minibag__expresspayment__intro');
        if (paymentDiv) {
            paymentDiv.classList.remove('button--arrow-left');
        }
    };
    const triggerPayment = (e) => {
        e.preventDefault();
        hideArrowAfterClick();
        props.onPaymentSelected();
        props.showFlagsCallback();
        setStartPayment(true);
    };
    useEffect(() => {
        if (props.paymentMethods) {
            setEnabled(!!props.paymentMethods.AdyenPaymentMethods.paymentMethods.find((p) => p.type == 'applepay'));
        }
    }, [props.paymentMethods]);
    if (!enabled || !window.ApplePaySession || !ApplePaySession.canMakePayments()) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("button", { type: "button", className: "button button--secondary dw-apple-pay-button dw-apple-pay-border dw-apple-pay-logo-white apple-pay-cart-button apple-pay-button", "aria-pressed": props.isSelected, "aria-controls": props.ariaControls, onClick: (e) => triggerPayment(e) },
        React.createElement("span", { className: "visually-hidden" }, "Apple Pay")));
};
export default ExpressPaymentsButtonApplepay;
